import { render } from "./TextHighlighter.vue?vue&type=template&id=288addf6&scoped=true"
import script from "./TextHighlighter.vue?vue&type=script&lang=js"
export * from "./TextHighlighter.vue?vue&type=script&lang=js"

import "./TextHighlighter.vue?vue&type=style&index=0&id=288addf6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288addf6"]])

export default __exports__